@import "../../constants.scss";

.entity-list {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: var(--spacing-1);

  &.no-gap {
    gap: 0;
  }
  .expanded-logos-trigger {
    width: 24px;
    display: flex;
    justify-content: center;
    height: 30px;
    align-items: center;
  }
  .more-logos-number {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-s);
    color: var(--primary-theme-color);

    &.is-disabled {
      color: var(--primary-main-color);
    }
  }
}

.expanded-logos-popover {
  @include dropdown-wrap();
  padding: 0 !important;

  .expanded-logos-list {
    padding: var(--spacing-2);
    display: flex;
    flex-flow: column nowrap;
    gap: var(--spacing-1);

    .expanded-list-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: var(--spacing-1);

      .logo {
        width: 20px;
        height: 20px;
      }

      .title {
        @include b2-typography();
        color: var(--text-color-main);
      }
    }
  }
}
